export const MAX_COMMENT_LENGTH = 2000

/** A blank comment is no comment: the rating is already saved without one. */
export function validateComment(
  raw: string
): { ok: true; comment: string | undefined } | { ok: false; reason: string } {
  const comment = raw.trim()

  if (comment.length > MAX_COMMENT_LENGTH) {
    return { ok: false, reason: `Use ${MAX_COMMENT_LENGTH} characters or fewer.` }
  }

  return { ok: true, comment: comment || undefined }
}
